import { render } from "./NcrmFileImportsTab.vue?vue&type=template&id=0ab0cadc&scoped=true"
import script from "./NcrmFileImportsTab.vue?vue&type=script&lang=js"
export * from "./NcrmFileImportsTab.vue?vue&type=script&lang=js"

import "./NcrmFileImportsTab.vue?vue&type=style&index=0&id=0ab0cadc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ab0cadc"]])

export default __exports__